export default __webpack_public_path__ + "e483cd0c5d5dec707a824310a0d26a79.jpg";